module.exports = require("superagent-promise-plugin");


//////////////////
// WEBPACK FOOTER
// external "superagent-promise-plugin"
// module id = 19
// module chunks = 0